import { getTranslation } from './utilities';
/* import MediaLibraryEvents from './media-library/events';*/

// Tours class
class TourGuide
{
    constructor()
    {
        // Imports
        this.driver = window.driver.js.driver;

        // Elements
        this.activateToursToggle = document.querySelector('.js-tour__activate-tours--toggle');

        // Helpers
        this.toursActive = JSON.parse(localStorage.getItem('toursActive')) !== false;
        this.toursShown = JSON.parse(localStorage.getItem('toursShown')) || [];
    }

    init()
    {
        this.initToggle();
        this.initTour();
    }

    initToggle()
    {
        if (this.activateToursToggle)
        {
            this.activateToursToggle.checked = this.toursActive;

            this.activateToursToggle.addEventListener('change', () =>
            {
                localStorage.setItem('toursActive', this.activateToursToggle.checked);
            });
        }
    }

    initTour()
    {
        this.tour = this.driver({
            prevBtnText: '<i class="fa-solid fa-angle-left"></i> ' + getTranslation('content.tour.prev.button'),
            nextBtnText: getTranslation('content.tour.next.button') + ' <i class="fa-solid fa-angle-right"></i>',
            doneBtnText: getTranslation('content.tour.done.button'),
            showButtons: ['previous', 'next', 'done', 'close'],
            onPopoverRender: (popover, { state }) =>
            {
                if (!popover.wrapper.querySelector('.driver-progress--container'))
                {
                    const progressContainer = document.createElement('div');
                    progressContainer.className = 'driver-progress--container';
                    popover.footer.prepend(progressContainer);

                    for (let i = 0; i < this.currentTourSteps.length; i++)
                    {
                        const progressStep = document.createElement('span');
                        progressStep.className = 'driver-progress--step';
                        progressContainer.appendChild(progressStep);
                    }
                }

                const currentStep = state.activeIndex + 1;
                const progressSteps = popover.wrapper.querySelectorAll('.driver-progress--step');

                progressSteps.forEach((step, index) =>
                {
                    step.classList.toggle('active', index < currentStep);
                });
            },
            onDestroyed: () =>
            {
                this.toursShown.push(this.currentTourLabel);

                localStorage.setItem('toursShown', JSON.stringify(this.toursShown));
            }
        });
    }

    startTour(label, steps)
    {
        this.currentTourLabel = label;
        this.currentTourSteps = steps;
        this.tour.setSteps(steps);
        this.tour.drive();
    }
}

// Config Tours
const mediaLibraryIntroLabel = 'mediaLibraryIntroTour';
const mediaLibraryIntroSteps = [
    {
        element: '#global',
        popover: {
            description:
                '<img src="/assets/images/content/b2b/tour/' +
                'tour-media-library-download-overlay.webp"' +
                'alt="" width="400px"/>' +
                '<span class="text--bold">' +
                getTranslation('content.media.library.download.tour') +
                '</span>'
        },
    },
    {
        element: '#global',
        popover: {
            description:
                '<img src="/assets/images/content/b2b/tour/tour-media-library-search.webp"  ' +
                'alt="" width="400px"/>' +
                '<span class="text--bold">' +
                getTranslation('content.media.library.search.tour') +
                '</span>'
        },
    },
    {
        element: '#global',
        popover: {
            description:
                '<img src="/assets/images/content/b2b/tour/tour-media-library-collection.webp"' +
                'alt="" width="400px"/>' +
                '<span class="text--bold">' +
                getTranslation('content.media.library.collection.tour') +
                '</span>'
        },
    },
    {
        element: '#global',
        popover: {
            description:
                '<img src="/assets/images/content/b2b/tour/tour-media-library-medium-1.webp"  ' +
                'alt="" width="400px"/>' +
                '<span class="text--bold">' +
                getTranslation('content.media.library.medium.tour') +
                '</span>'
        },
    },
    // {
    //     element: '#global',
    //     popover: {
    //         description:
    //             '<img src="/assets/images/content/b2b/tour/media-library-help-1.webp"  ' +
    //             'alt="" width="400px"/>' +
    //             '<span class="text--bold">' +
    //             getTranslation('content.tour.media.library.help.text') +
    //             '</span>'
    //     },
    // },
];

// Init tours
const tour = new TourGuide();
tour.init();

if (tour.toursActive)
{
    if (
        document.querySelector('body').classList.contains('authorized') &&
        document.querySelector('body').id === 'media-library-search'
    )
    {
        if (!tour.toursShown.includes(mediaLibraryIntroLabel))
        {
            tour.startTour(mediaLibraryIntroLabel, mediaLibraryIntroSteps);
        }
    }
}
